var _rect, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssessmentHead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_116_13028)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 44,
    height: 44,
    rx: 22,
    fill: "#17A1FA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_116_13028",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 12,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0293 33.3532V12.6472H13.3232V33.3532H34.0293Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.647059
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_116_13028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9341 19.6562H33.4146C33.7599 19.6562 34.0402 19.9365 34.0402 20.2818V31.0337C34.0402 31.3795 33.7599 31.6593 33.4146 31.6593H23.6765H13.9384C13.5931 31.6593 13.3128 31.3795 13.3128 31.0337V20.2818C13.3128 19.9365 13.5931 19.6562 13.9384 19.6562H15.4189",
    stroke: "white",
    strokeWidth: 0.647059,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9341 26.7378V29.4907C31.9341 29.6519 31.8034 29.7826 31.6421 29.7826H26.5618C25.3135 29.7826 24.1825 30.5182 23.6765 31.6593V20.1487C23.6765 18.9971 24.6101 18.0635 25.7617 18.0635H31.6421C31.8034 18.0635 31.9341 18.1942 31.9341 18.3554V25.2781",
    stroke: "white",
    strokeWidth: 0.647059,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7108 29.7826H20.7912C22.0395 29.7826 23.1704 30.5183 23.6765 31.6593V20.1487C23.6765 18.9971 22.7429 18.0635 21.5912 18.0635H15.7108C15.5496 18.0635 15.4189 18.1942 15.4189 18.3554V29.4907C15.4189 29.6519 15.5496 29.7826 15.7108 29.7826Z",
    stroke: "white",
    strokeWidth: 0.647059,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.06 16.2779H16.5777L15.6244 15.5393C15.4735 15.4224 15.4735 15.1946 15.6244 15.0778L16.5777 14.3392H31.4246C31.655 14.3392 31.8417 14.5259 31.8417 14.7562V15.8608C31.8417 16.0912 31.655 16.2779 31.4246 16.2779H21.5197",
    stroke: "white",
    strokeWidth: 0.647059,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9649 16.2779V14.3392H31.4245C31.6549 14.3392 31.8416 14.5259 31.8416 14.7562V15.8608C31.8416 16.0912 31.6549 16.2779 31.4245 16.2779H29.9649Z",
    stroke: "white",
    strokeWidth: 0.647059,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5777 14.3392C16.6429 14.4121 17.0028 14.8288 16.9504 15.4341C16.9113 15.8848 16.666 16.1806 16.5777 16.2779",
    stroke: "white",
    strokeWidth: 0.647059,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2489 20.2955H30.3616",
    stroke: "white",
    strokeWidth: 0.647059,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2489 22.1733H30.3616",
    stroke: "white",
    strokeWidth: 0.647059,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2489 24.0498H30.3616",
    stroke: "white",
    strokeWidth: 0.647059,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2489 25.9257H30.3616",
    stroke: "white",
    strokeWidth: 0.647059,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2489 27.8024H30.3617",
    stroke: "white",
    strokeWidth: 0.647059,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9913 20.2955H22.1041",
    stroke: "white",
    strokeWidth: 0.647059,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9913 22.1733H22.1041",
    stroke: "white",
    strokeWidth: 0.647059,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9913 24.0498H22.1041",
    stroke: "white",
    strokeWidth: 0.647059,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9913 25.9257H22.1041",
    stroke: "white",
    strokeWidth: 0.647059,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9913 27.8024H22.1041",
    stroke: "white",
    strokeWidth: 0.647059,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_116_13028",
    x: 0.307692,
    y: 0.153846,
    width: 49.0769,
    height: 49.0769,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.846154,
    dy: 1.69231
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.26923
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.09 0 0 0 0 0.63 0 0 0 0 0.98 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_116_13028"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_116_13028",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentHead);
export default __webpack_public_path__ + "static/media/AssessmentHead.a319853e9f884e0f8036c3a97c58eb04.svg";
export { ForwardRef as ReactComponent };